import { render, staticRenderFns } from "./ContactList.vue?vue&type=template&id=1b4fbfc6&scoped=true&"
import script from "./ContactList.vue?vue&type=script&lang=js&"
export * from "./ContactList.vue?vue&type=script&lang=js&"
import style0 from "./ContactList.vue?vue&type=style&index=0&id=1b4fbfc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4fbfc6",
  null
  
)

export default component.exports